"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RecoverLinksMigration", {
    enumerable: true,
    get: function() {
        return RecoverLinksMigration;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _utils = require("~/utils");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let RecoverLinksMigration = class RecoverLinksMigration {
    async job() {
        // start transaction
        const ncMeta = await _Noco.default.ncMeta.startTransaction();
        try {
            // Get all broken link columns which doesn't have colOptions
            const columns = await ncMeta.knex(_globals.MetaTable.COLUMNS).select(`${_globals.MetaTable.COLUMNS}.*`).leftJoin(_globals.MetaTable.COL_RELATIONS, `${_globals.MetaTable.COLUMNS}.id`, `${_globals.MetaTable.COL_RELATIONS}.fk_column_id`).where(`${_globals.MetaTable.COLUMNS}.uidt`, _nocodbsdk.UITypes.LinkToAnotherRecord).whereNull(`${_globals.MetaTable.COL_RELATIONS}.id`);
            // Recover broken link
            for (const column of columns){
                this.log(`Recovering column '${column.title}' (ID: '${column.id}')`);
                let relatedTableId;
                // check any lookup or rollup column is using this column
                const lookupColumns = await ncMeta.knex(_globals.MetaTable.COL_LOOKUP).select(`${_globals.MetaTable.COL_LOOKUP}.*`).where(`${_globals.MetaTable.COL_LOOKUP}.fk_relation_column_id`, column.id);
                for (const lookupColumn of lookupColumns){
                    const lookupCol = await ncMeta.knex(_globals.MetaTable.COLUMNS).select(`${_globals.MetaTable.COLUMNS}.fk_model_id`).where(`${_globals.MetaTable.COLUMNS}.id`, lookupColumn.fk_lookup_column_id).first();
                    if (lookupCol) {
                        relatedTableId = lookupCol.fk_model_id;
                        break;
                    }
                }
                if (!relatedTableId) {
                    const rollupColumns = await ncMeta.knex(_globals.MetaTable.COL_ROLLUP).select(`${_globals.MetaTable.COL_ROLLUP}.*`).where(`${_globals.MetaTable.COL_ROLLUP}.fk_relation_column_id`, column.id);
                    for (const rollupColumn of rollupColumns){
                        const rollupCol = await ncMeta.knex(_globals.MetaTable.COLUMNS).select(`${_globals.MetaTable.COLUMNS}.fk_model_id`).where(`${_globals.MetaTable.COLUMNS}.id`, rollupColumn.fk_rollup_column_id).first();
                        if (rollupCol) {
                            relatedTableId = rollupCol.fk_model_id;
                            break;
                        }
                    }
                }
                // if related table is not found then iterate over all links which is related to current table
                const linksQb = ncMeta.knex(_globals.MetaTable.COL_RELATIONS).select(`${_globals.MetaTable.COL_RELATIONS}.*`).select(`${_globals.MetaTable.COLUMNS}.fk_model_id`).where(`${_globals.MetaTable.COL_RELATIONS}.fk_related_model_id`, column.fk_model_id).join(_globals.MetaTable.COLUMNS, `${_globals.MetaTable.COL_RELATIONS}.fk_column_id`, `${_globals.MetaTable.COLUMNS}.id`);
                if (relatedTableId) {
                    linksQb.where(`${_globals.MetaTable.COLUMNS}.fk_model_id`, relatedTableId);
                }
                const links = await linksQb;
                let foundAndMapped = false;
                // iterate over all links which is related to current table and if found relation which doesn't have link in the related table then use it to populate colOptions
                for (const link of links){
                    const relatedTableId = link.fk_model_id;
                    let columnInCurrTable = null;
                    if (link.type === _nocodbsdk.RelationTypes.HAS_MANY) {
                        // check for bt column in current table
                        columnInCurrTable = await ncMeta.knex(_globals.MetaTable.COL_RELATIONS).join(_globals.MetaTable.COLUMNS, `${_globals.MetaTable.COL_RELATIONS}.fk_column_id`, `${_globals.MetaTable.COLUMNS}.id`).where(`${_globals.MetaTable.COL_RELATIONS}.fk_related_model_id`, relatedTableId).where(`${_globals.MetaTable.COL_RELATIONS}.type`, _nocodbsdk.RelationTypes.BELONGS_TO).where(`${_globals.MetaTable.COL_RELATIONS}.fk_child_column_id`, link.fk_child_column_id).where(`${_globals.MetaTable.COL_RELATIONS}.fk_parent_column_id`, link.fk_parent_column_id).first();
                    } else if (link.type === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
                        // check for one to one column in current table and confirm type in meta
                        columnInCurrTable = await ncMeta.knex(_globals.MetaTable.COL_RELATIONS).join(_globals.MetaTable.COLUMNS, `${_globals.MetaTable.COL_RELATIONS}.fk_column_id`, `${_globals.MetaTable.COLUMNS}.id`).where(`${_globals.MetaTable.COL_RELATIONS}.fk_related_model_id`, relatedTableId).where(`${_globals.MetaTable.COL_RELATIONS}.type`, _nocodbsdk.RelationTypes.ONE_TO_ONE).where(`${_globals.MetaTable.COL_RELATIONS}.fk_child_column_id`, link.fk_child_column_id).where(`${_globals.MetaTable.COL_RELATIONS}.fk_parent_column_id`, link.fk_parent_column_id).first();
                    } else if (link.type === _nocodbsdk.RelationTypes.BELONGS_TO) {
                        // check for hm column in current table
                        columnInCurrTable = await ncMeta.knex(_globals.MetaTable.COL_RELATIONS).join(_globals.MetaTable.COLUMNS, `${_globals.MetaTable.COL_RELATIONS}.fk_column_id`, `${_globals.MetaTable.COLUMNS}.id`).where(`${_globals.MetaTable.COL_RELATIONS}.fk_related_model_id`, relatedTableId).where(`${_globals.MetaTable.COL_RELATIONS}.type`, _nocodbsdk.RelationTypes.HAS_MANY).where(`${_globals.MetaTable.COL_RELATIONS}.fk_child_column_id`, link.fk_child_column_id).where(`${_globals.MetaTable.COL_RELATIONS}.fk_parent_column_id`, link.fk_parent_column_id).first();
                    } else if (link.type === _nocodbsdk.RelationTypes.MANY_TO_MANY) {
                        // check for mtm column in current table
                        columnInCurrTable = await ncMeta.knex(_globals.MetaTable.COL_RELATIONS).join(_globals.MetaTable.COLUMNS, `${_globals.MetaTable.COL_RELATIONS}.fk_column_id`, `${_globals.MetaTable.COLUMNS}.id`).where(`${_globals.MetaTable.COL_RELATIONS}.fk_related_model_id`, relatedTableId).where(`${_globals.MetaTable.COL_RELATIONS}.type`, _nocodbsdk.RelationTypes.BELONGS_TO).where(`${_globals.MetaTable.COL_RELATIONS}.fk_child_column_id`, link.fk_parent_column_id).where(`${_globals.MetaTable.COL_RELATIONS}.fk_parent_column_id`, link.fk_parent_column_id).where(`${_globals.MetaTable.COL_RELATIONS}.fk_mm_model_id`, link.fk_mm_model_id).where(`${_globals.MetaTable.COL_RELATIONS}.fk_mm_child_column_id`, link.fk_mm_parent_column_id).where(`${_globals.MetaTable.COL_RELATIONS}.fk_mm_parent_column_id`, link.fk_mm_child_column_id).first();
                    }
                    if (!columnInCurrTable) {
                        // generate meta and insert into colOptions
                        const commonProps = {
                            id: await ncMeta.genNanoid(_globals.MetaTable.COL_RELATIONS),
                            fk_column_id: column.id,
                            fk_related_model_id: relatedTableId,
                            created_at: link.created_at,
                            updated_at: link.updated_at,
                            virtual: link.virtual,
                            base_id: link.base_id
                        };
                        if (_utils.isEE) {
                            commonProps.fk_workspace_id = link.fk_workspace_id;
                        }
                        // based on type insert data into colOptions
                        switch(link.type){
                            case _nocodbsdk.RelationTypes.HAS_MANY:
                                // insert data into colOptions
                                await ncMeta.knex(_globals.MetaTable.COL_RELATIONS).insert(_extends({}, commonProps, {
                                    type: _nocodbsdk.RelationTypes.BELONGS_TO,
                                    fk_child_column_id: link.fk_child_column_id,
                                    fk_parent_column_id: link.fk_parent_column_id
                                }));
                                break;
                            case _nocodbsdk.RelationTypes.ONE_TO_ONE:
                                {
                                    // insert data into colOptions
                                    await ncMeta.knex(_globals.MetaTable.COL_RELATIONS).insert(_extends({}, commonProps, {
                                        type: _nocodbsdk.RelationTypes.ONE_TO_ONE,
                                        fk_child_column_id: link.fk_child_column_id,
                                        fk_parent_column_id: link.fk_parent_column_id
                                    }));
                                }
                                break;
                            case _nocodbsdk.RelationTypes.BELONGS_TO:
                                // insert data into colOptions
                                await ncMeta.knex(_globals.MetaTable.COL_RELATIONS).insert(_extends({}, commonProps, {
                                    type: _nocodbsdk.RelationTypes.HAS_MANY,
                                    fk_child_column_id: link.fk_child_column_id,
                                    fk_parent_column_id: link.fk_parent_column_id
                                }));
                                break;
                            case _nocodbsdk.RelationTypes.MANY_TO_MANY:
                                // insert data into colOptions
                                await ncMeta.knex(_globals.MetaTable.COL_RELATIONS).insert(_extends({}, commonProps, {
                                    type: _nocodbsdk.RelationTypes.MANY_TO_MANY,
                                    fk_child_column_id: link.fk_parent_column_id,
                                    fk_parent_column_id: link.fk_child_column_id,
                                    fk_mm_model_id: link.fk_mm_model_id,
                                    fk_mm_child_column_id: link.fk_mm_parent_column_id,
                                    fk_mm_parent_column_id: link.fk_mm_child_column_id
                                }));
                                break;
                        }
                        foundAndMapped = true;
                        break;
                    }
                }
                if (!foundAndMapped) {
                    this.log(`No related column found for link column '${column.title}' (ID: '${column.id}'). Deleting it.`);
                    // delete the link column since it's not useful anymore and not recoverable
                    await _models.Column.delete({
                        workspace_id: column.workspace_id,
                        base_id: column.base_id
                    }, column.id, ncMeta);
                } else {
                    this.log(`Recovered column '${column.title}' (ID: '${column.id}')`);
                }
            }
            this.log('Recovery completed');
            await ncMeta.commit();
        } catch (e) {
            await ncMeta.rollback(e);
            this.log('Error recovering links', e);
            return false;
        }
        return true;
    }
    constructor(){
        this.debugLog = (0, _debug.default)('nc:migration-jobs:recover-links');
        this.log = (...msgs)=>{
            console.log('[nc_job_003_recover_links]: ', ...msgs);
        };
    }
};
RecoverLinksMigration = _ts_decorate([
    (0, _common.Injectable)()
], RecoverLinksMigration);
